import { render, staticRenderFns } from "./HowToGet.vue?vue&type=template&id=8d0883f4"
import script from "./HowToGet.vue?vue&type=script&lang=js"
export * from "./HowToGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports